import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from './InputField';

const InsuranceContractSearch = ({ handleSubmit }) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field
        component={InputField}
        type="number"
        name="att_subscription"
        label="AT&T Subscription"
      />
      <Field
        component={InputField}
        type="number"
        name="quick_subscription"
        label="Quick Subscription"
      />
      <Field
        component={InputField}
        type="number"
        name="user_profile"
        label="User Profile ID"
      />
      <button className="btn btn-default">Search</button>
    </form>
  </div>
);

export default reduxForm({
  form: 'searchContracts',
})(InsuranceContractSearch);
